module.exports = __webpack_public_path__ + "static/media/组 4463@2x.4aeb476e.png";